__turbopack_context__.v({
  "active": "collapsible-module-scss-module__lM-ExG__active",
  "buttonText": "collapsible-module-scss-module__lM-ExG__buttonText",
  "collapseContainer": "collapsible-module-scss-module__lM-ExG__collapseContainer",
  "collapsibleButton": "collapsible-module-scss-module__lM-ExG__collapsibleButton",
  "collapsiblePara": "collapsible-module-scss-module__lM-ExG__collapsiblePara",
  "content": "collapsible-module-scss-module__lM-ExG__content",
  "faqContainer": "collapsible-module-scss-module__lM-ExG__faqContainer",
  "faqHeading": "collapsible-module-scss-module__lM-ExG__faqHeading",
});
